require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/fn/get-iterator.js
// module id = 1006
// module chunks = 0